import { baseURL, getIdToken } from "./client";

// Axios
import axios from "axios";

/**
 *
 * @param {string} waybillNumber
 * @param {number} pageSize
 * @param {number} pageNumber
 * @returns
 */

export const getBuyerAttempts = async ({ waybillNumber }) => {
  return axios({
    baseURL,
    url: `/shipments/${waybillNumber}/attempts`,
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
  }).then(response => response.data);
};
